export function capitalize(text: string) {
  if (text !== undefined) {
    const lower = text.toLowerCase();
    const capitalizeText = text.charAt(0).toUpperCase() + lower.slice(1);
    return capitalizeText.replace(/_/g, " ");
  }
}
